// Single source of truth for password requirements, shared by the
// registration and change-password forms so they can't drift.

export type PasswordRule = { id: string; label: string; met: boolean };

export function validatePassword(password: string): PasswordRule[] {
  return [
    { id: 'length', label: 'At least 8 characters', met: password.length >= 8 },
    { id: 'upper', label: 'One uppercase letter', met: /[A-Z]/.test(password) },
    { id: 'number', label: 'One number', met: /[0-9]/.test(password) },
    {
      id: 'special',
      label: 'One special character (!@#$%^&*)',
      met: /[!@#$%^&*]/.test(password),
    },
  ];
}

export const isPasswordValid = (password: string): boolean =>
  validatePassword(password).every((r) => r.met);
